import React, { useState } from 'react';
import { X } from 'lucide-react';
import Button from './Button';
import { useAuth } from '../context/AuthContext';
import { upgradeToDesigner } from '../api/client';
import './AuthModal.css'; // Reuse styles

export default function DesignerOnboarding({ isOpen, onClose, onSuccess }) {
  const { user, session } = useAuth();
  
  const [bio, setBio] = useState('');
  const [location, setLocation] = useState('');
  const [website, setWebsite] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen || !user) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await upgradeToDesigner({
        bio,
        location,
        website_url: website,
        skills: ['UI Design']
      });

      onSuccess();
      onClose();
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-container animate-fade-in">
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          <X size={20} />
        </button>
        
        <div className="modal-header">
          <h2 className="text-h2">Become a Designer</h2>
          <p className="text-secondary text-caption">
            Complete your profile to start sharing your templates with the community.
          </p>
        </div>
        
        <div className="modal-content">
          <form className="email-auth-form" onSubmit={handleSubmit}>
            {error && <div style={{ color: 'var(--status-error)', fontSize: '14px', marginBottom: '12px' }}>{error}</div>}
            
            <div className="form-group">
              <label htmlFor="bio">Bio</label>
              <textarea 
                id="bio" 
                placeholder="Tell us about yourself..." 
                className="form-input" 
                style={{ resize: 'vertical', minHeight: '80px' }}
                value={bio} 
                onChange={e => setBio(e.target.value)} 
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="location">Location</label>
              <input type="text" id="location" placeholder="e.g. Tokyo, Japan" className="form-input" value={location} onChange={e => setLocation(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="website">Website / Portfolio</label>
              <input type="url" id="website" placeholder="https://..." className="form-input" value={website} onChange={e => setWebsite(e.target.value)} />
            </div>
            
            <Button variant="primary" className="w-full mt-4" disabled={loading}>
              {loading ? 'Upgrading...' : 'Complete Profile & Upgrade'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
